





































































































































import {Component, Vue} from "vue-property-decorator";

import {userStore} from "@/store/store";
import LoginModal from "@/views/components/home/LoginModal.vue";
import {marketing_url} from "@/main";

@Component({
  computed: {},
  components: {
    LoginModal,
  },
})
export default class Main extends Vue {
  get userIsLoggedIn() {
    return userStore.userIsLoggedIn;
  }

  get year() {
    return new Date().getFullYear();
  }

  get user() {
    return userStore.user;
  }

  get userHasShared() {
    if (this.user !== null && this.user.num_shared !== undefined) {
      return this.user.num_shared > 0;
    }
    return false;
  }

  marketingUrl = marketing_url;

  logoutUser() {
    userStore.setLoggedOut();
  }


}
